const ReadyRosterTranslations = {
  en: {
    // Search and Filter Labels
    search_by_athlete_name: "Search by athlete name",
    select_sport: "Select Sport",
    select_weight_class: "Select Weight Class",
    gender:"Gender",
    select_roster_statuses: "Select Roster statuses",
    no_sports_available: "No sports available",
    no_weight_classes_available: "No weight classes available",
    no_roster_statuses_available: "No Roster statuses available",
    reset_all_filters: "Reset all filters",
    create_ready_roster: "Create Ready Roster",
    contact_invite_success:"Contact invitation sent successfully!",

    // Tabs
    ready_rosters: "Ready Rosters",
    my_ready_rosters: "My ready rosters",

    // Card Labels
    view_count: "View Count: {{count}}",
    sport: "Sport",
    purse: "Purse",
    weight_class: "Weight Class",
    level: "Level",
    location: "Location",
    valid_upto: "Valid Until ",
    published: "Published",
    available: "Available",
    expired: "Expired",
    ready_roster_detail: "Ready Roster Detail",
    profile_details: "Profile Details",
    date_of_birth: "Date of Birth",
    title_holder: "Title Holder",
    height: "Height",
    weight: "Weight",
    reach: "Reach",
    stance: "Stance",
    training_disciplines: "Training Disciplines",
    weight_classes: "Weight Classes",
    financial_information: "Financial Information",
    currency: "Currency",
    match_information: "Match Information",
    roster_status: "Roster Status",
    location_travel: "Location & Travel",
    travel_ready: "Travel Ready",
    validity: "Validity",
    created_at: "Created At",
    available_regions: "Available Regions",
    availability: "Availability",
    available_dates: "Available Dates",
    notes: "Notes",
    no_regions_specified: "No regions specified",
    date_selected: "{{count}} date selected",
    dates_selected: "{{count}} dates selected",
    preferred_ruleset: "Level",

    // Buttons
    contact: "Contact",
    contacted: "Contacted",
    publish: "Publish",
    publishing: "Publishing...",
    close: "Close",
    report_abuse: "Report Abuse",
    reported: "Reported",
    edit: "Edit",
    delete: "Delete",

    // Confirm Modals
    confirm_contact: "Confirm Contact",
    confirm_contact_description: "Are you sure you want to contact the fighter for this ready roster?",
    confirm_publish: "Confirm Publish",
    confirm_publish_description: "Are you sure you want to publish this ready roster?",
    confirm: "Confirm",

    // Empty State
    no_fighters_found: "No fighters found",
    no_fighters_found_description: "Try adjusting your search criteria or create a new roster entry.",

    // Error Messages
    failed_to_publish_card: "Failed to publish card",
    failed_to_load_training_disciplines: "Failed to load training disciplines",
    failed_to_load_weight_classes: "Failed to load weight classes",
    failed_to_load_roster_statuses: "Failed to load Roster statuses",
     card_published_successfully:"Card Published Successfully",
  },

  de: {
    // Search and Filter Labels
    search_by_athlete_name: "Nach Athletenname suchen",
    select_sport: "Sport auswählen",
    select_weight_class: "Gewichtsklasse auswählen",
    select_roster_statuses: "Roster-Status auswählen",
    gender: "Geschlecht",
    no_sports_available: "Keine Sportarten verfügbar",
    no_weight_classes_available: "Keine Gewichtsklassen verfügbar",
    no_roster_statuses_available: "Keine Roster-Status verfügbar",
    reset_all_filters: "Alle Filter zurücksetzen",
    create_ready_roster: "Bereiten Roster erstellen",
    preferred_ruleset: "Stufe",
    contact_invite_success: "Kontaktanfrage erfolgreich gesendet!",

    // Tabs
    ready_rosters: "Bereite Roster",
    my_ready_rosters: "Meine bereiten Roster",

    // Card Labels
    view_count: "Ansichten: {{count}}",
    sport: "Sport",
    purse: "Preisgeld",
    weight_class: "Gewichtsklasse",
    level: 'Stufe',
    location: "Ort",
    availability: 'Verfügbarkeit',
    valid_upto: "Gültig bis",
    published: "Veröffentlicht",
    available: "Verfügbar",
    expired: "Abgelaufen",

    // Modal Labels
    ready_roster_detail: "Bereit Roster Details",
    profile_details: "Profil Details",
    date_of_birth: "Geburtsdatum",
    title_holder: "Titelträger",
    height: "Größe",
    weight: "Gewicht",
    reach: "Reichweite",
    stance: "Haltung",
    training_disciplines: "Trainingsdisziplinen",
    weight_classes: "Gewichtsklassen",
    financial_information: "Finanzielle Informationen",
    currency: "Währung",
    match_information: "Match-Informationen",
    roster_status: "Roster-Status",
    location_travel: "Ort & Reise",
    travel_ready: "Reisebereit",
    validity: "Gültigkeit",
    created_at: "Erstellt am",
    available_regions: "Verfügbare Regionen",
    available_dates: "Verfügbare Daten",
    notes: "Notizen",
    no_regions_specified: "Keine Regionen angegeben",
    date_selected: "{{count}} Datum ausgewählt",
    dates_selected: "{{count}} Daten ausgewählt",

    // Buttons
    contact: "Kontaktieren",
    contacted: "Kontaktiert",
    publish: "Veröffentlichen",
    publishing: "Veröffentlichen...",
    close: "Schließen",
    report_abuse: "Missbrauch melden",
    reported: "Gemeldet",
    edit: "Bearbeiten",
    delete: "Löschen",

    // Confirm Modals
    confirm_contact: "Kontakt bestätigen",
    confirm_contact_description: "Sind Sie sicher, dass Sie den Kämpfer für dieses Ready Roster kontaktieren möchten?",
    confirm_publish: "Veröffentlichung bestätigen",
    confirm_publish_description: "Sind Sie sicher, dass Sie dieses Ready Roster veröffentlichen möchten?",
    confirm: "Bestätigen",

    // Empty State
    no_fighters_found: "Keine Kämpfer gefunden",
    no_fighters_found_description: "Versuchen Sie, Ihre Suchkriterien anzupassen oder einen neuen Roster-Eintrag zu erstellen.",

    // Error Messages
    failed_to_publish_card: "Veröffentlichung der Karte fehlgeschlagen",
    failed_to_load_training_disciplines: "Laden der Trainingsdisziplinen fehlgeschlagen",
    failed_to_load_weight_classes: "Laden der Gewichtsklassen fehlgeschlagen",
    failed_to_load_roster_statuses: "Laden der Roster-Status fehlgeschlagen",
        card_published_successfully: 'Karte erfolgreich veröffentlicht',

  },

  hr: {
    // Search and Filter Labels
    search_by_athlete_name: "Pretraži po imenu sportaša",
    select_sport: "Odaberite sport",
    select_weight_class: "Odaberite težinsku kategoriju",
    select_roster_statuses: "Odaberite status liste",
    no_sports_available: "Nema dostupnih sportova",
    no_weight_classes_available: "Nema dostupnih težinskih kategorija",
    no_roster_statuses_available: "Nema dostupnih statusa liste",
    reset_all_filters: "Poništi sve filtre",
    create_ready_roster: "Kreiraj spremnu listu",
    preferred_ruleset: "Razina",
       card_published_successfully: 'Kartica je uspješno objavljena',
       contact_invite_success: "Poziv za kontakt uspješno poslan!",
    // Tabs
    ready_rosters: "Spremne liste",
    my_ready_rosters: "Moje spremne liste",

    // Card Labels
    view_count: "Pregledi: {{count}}",
    sport: "Sport",
    purse: "Nagrada",
    weight_class: "Težinska kategorija",
    level: 'Razina',
    availability: 'Dostupnost',
    location: "Lokacija",
    valid_upto: "Vrijedi do",
    published: "Objavljeno",
    available: "Dostupno",
    expired: "Isteklo",

    // Modal Labels
    ready_roster_detail: "Detalji spremne liste",
    profile_details: "Detalji profila",
    date_of_birth: "Datum rođenja",
    title_holder: "Držalac titule",
    height: "Visina",
    weight: "Težina",
    reach: "Doseg",
    stance: "Stav",
    training_disciplines: "Discipline treninga",
    weight_classes: "Težinske kategorije",
    financial_information: "Financijske informacije",
    currency: "Valuta",
    match_information: "Informacije o meču",
    roster_status: "Status liste",
    location_travel: "Lokacija i putovanja",
    travel_ready: "Spreman za putovanja",
    validity: "Valjanost",
    created_at: "Kreirano",
    available_regions: "Dostupne regije",
    available_dates: "Dostupni datumi",
    notes: "Bilješke",
    no_regions_specified: "Nema navedenih regija",
    date_selected: "{{count}} datum odabran",
    dates_selected: "{{count}} datuma odabrano",

    // Buttons
    contact: "Kontaktiraj",
    contacted: "Kontaktirano",
    publish: "Objavi",
    publishing: "Objavljivanje...",
    close: "Zatvori",
    report_abuse: "Prijavi zloupotrebu",
    reported: "Prijavljeno",
    edit: "Uredi",
      gender: "Spol",
    delete: "Obriši",

    // Confirm Modals
    confirm_contact: "Potvrdi kontakt",
    confirm_contact_description: "Jeste li sigurni da želite kontaktirati borca za ovu spremnu listu?",
    confirm_publish: "Potvrdi objavu",
    confirm_publish_description: "Jeste li sigurni da želite objaviti ovu spremnu listu?",
    confirm: "Potvrdi",

    // Empty State
    no_fighters_found: "Nema pronađenih boraca",
    no_fighters_found_description: "Pokušajte prilagoditi kriterije pretraživanja ili kreirati novi unos liste.",

    // Error Messages
    failed_to_publish_card: "Neuspjelo objavljivanje kartice",
    failed_to_load_training_disciplines: "Neuspjelo učitavanje disciplina treninga",
    failed_to_load_weight_classes: "Neuspjelo učitavanje težinskih kategorija",
    failed_to_load_roster_statuses: "Neuspjelo učitavanje statusa liste",
  },
};

export default ReadyRosterTranslations;